<script setup lang="ts">
interface IProviderProps {
  provider: string;
  isCarousel?: boolean;
}
const route = useRoute();
const router = useRouter();
const props = withDefaults(defineProps<IProviderProps>(), {
  isCarousel: false,
});

const { getDynamicImage, getPlaceholder } = useBranding();

const regex = / /g;

const transpiledName = computed(() => `${props.provider.replace(regex, '-')}`);

function navigateToProvider() {
  if (!route.params.contentType)
    return router.push(`/home/providers/${transpiledName.value.toLowerCase()}`);
  return router.push(
    `/${
      route.params.contentType
    }/providers/${transpiledName.value.toLowerCase()}`,
  );
}
</script>

<template>
  <div
    :class="`${
      props.isCarousel ? 'is-carousel' : 'w-full'
    } provider-card py-2 rounded-lg bg-white dark:bg-dark-800 fit-contain h-14 flex-shrink-0 overflow-hidden flex items-center justify-center blue-gradient-hover glow cursor-pointer`"
    @click="navigateToProvider()"
  >
    <DesignSystemLazyImage
      class="provider-image max-h-[44px] p-1 invert dark:invert-0 md:max-w-max overflow-hidden"
      :placeholder="getPlaceholder('iconPlaceholder')"
      :src="getDynamicImage('casinoProviders', { provider: transpiledName })"
      :alt="provider"
    />
  </div>
</template>

<style scoped>
* {
  user-select: contain;
}
.provider-image:hover {
  filter: unset !important;
}
::selection {
  background: transparent;
}
::-moz-selection {
  background: transparent;
}
</style>
